export default {
  'home.name': 'Tài liệu',
  'home.title': 'Tài liệu',
  'home.fileName': 'Tên File',
  'home.fullPath': 'Đường dẫn',
  'home.contentType': 'Loại file',
  'home.createdAt': 'Ngày tạo',
  'home.confirm.title.delete': 'Xóa File',
  'home.confirm.content.delete': 'Bạn đồng ý xóa những file này ?',
  'home.create': 'Thêm mới file',
  'home.action': 'Hành Động',
  'home.memberSelect': 'Đối tượng',
  'home.memberSelect-placeholder': 'Chọn đối tượng',
  'home.member': 'Đảng viên',
  'home.memberAndPartner': 'Ban chấp hành',
  'home.represents': 'Cấp ủy',
  'home.accepts': 'Đối tượng',
};
